import script from "./sborka.vue?vue&type=script&setup=true&lang=js"
export * from "./sborka.vue?vue&type=script&setup=true&lang=js"

import "./sborka.vue?vue&type=style&index=0&id=2741fe69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2741fe69"]])

export default __exports__